import { render, staticRenderFns } from "./HeroResetConformationDialog.vue?vue&type=template&id=778df706&"
import script from "./HeroResetConformationDialog.vue?vue&type=script&lang=js&"
export * from "./HeroResetConformationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports